import Hero from "../components/Hero";
import AboutSection from "../components/AboutSection";
import SolutionsOverview from "../components/SolutionsOverview";
import OperationalDashboards from "../components/OperationalDashboards";
import IntelligenceSecurity from "../components/IntelligenceSecurity";
import SummaryStats from "../components/SummaryStats";
import CTASection from "../components/CTASection";

function Home() {
  return (
    <>
      <Hero />
      <AboutSection />
      <SolutionsOverview />
      <OperationalDashboards />
      <IntelligenceSecurity />
      <SummaryStats />
      <CTASection />
    </>
  );
}

export default Home;